import type React from 'react';

import type { ErrorHandlerProps } from '#src/app/pages/homepage/pageContext';

export const HomepageErrorHandler: React.FC<ErrorHandlerProps> = ({ context: { error } }) => {
	throw new Error(`Failed to retrieve data for Homepage page (error: ${error})`);
};
